import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import firebase from 'firebase/app'
// import 'firebase/auth'
import 'firebase/firestore'
import VueGtag from 'vue-gtag'

import config from './config.js'
import VueCookies from 'vue-cookies'
import VueClipboard from 'vue-clipboard2'
var SocialSharing = require('vue-social-sharing')

firebase.initializeApp(config.firebaseConfig)

Vue.use(VueCookies)
Vue.use(VueClipboard)
Vue.use(SocialSharing)

if (process.env.NODE_ENV !== 'development') {
  // console.log('VueGtag is ' + config.analyticsID)
  Vue.use(VueGtag, {
    config: { id: config.analyticsID }
  })
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
